function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
import { ERROR_SUFFIX_HDCP_DECODE, ERROR_SUFFIX_WINDOWS_HDCP_DECODE, ErrorSeverity, ErrorReason, CvsdkError } from '../../error';
import { JsonUtils } from '../../utils/json-utils';
import { sdkLogger } from '../../logger';
export var ShakaPlayerError = /*#__PURE__*/ function(CvsdkError) {
    "use strict";
    _inherits(ShakaPlayerError, CvsdkError);
    function ShakaPlayerError(code, message, severity, cause, category, reason, parameters) {
        _class_call_check(this, ShakaPlayerError);
        var _this;
        var calculatedReason = reason !== null && reason !== void 0 ? reason : ErrorReason.Undetermined;
        _this = _call_super(this, ShakaPlayerError, [
            code,
            message,
            severity,
            cause,
            category,
            calculatedReason,
            parameters
        ]), _define_property(_this, "parameters", void 0), _this.parameters = parameters;
        Object.setPrototypeOf(_this, ShakaPlayerError.prototype);
        // restore prototype chain
        _this.name = 'ShakaPlayerError';
        return _this;
    }
    _create_class(ShakaPlayerError, null, [
        {
            key: "from",
            value: function from(param) {
                var code = param.code, message = param.message, severity = param.severity, cause = param.cause, category = param.category, reason = param.reason, parameters = param.parameters;
                return new ShakaPlayerError(code, message, severity, cause, category, reason, parameters);
            }
        },
        {
            key: "isErrorHDCP",
            value: function isErrorHDCP(error) {
                var _error_data__restrictedKeyStatuses, _error_data_, _error_data;
                return error.code === shaka.util.Error.Code.RESTRICTIONS_CANNOT_BE_MET && ((_error_data = error.data) === null || _error_data === void 0 ? void 0 : (_error_data_ = _error_data[0]) === null || _error_data_ === void 0 ? void 0 : (_error_data__restrictedKeyStatuses = _error_data_.restrictedKeyStatuses) === null || _error_data__restrictedKeyStatuses === void 0 ? void 0 : _error_data__restrictedKeyStatuses[0]) === 'output-restricted';
            }
        },
        {
            key: "isErrorWindowsHDCP",
            value: function isErrorWindowsHDCP(error) {
                var _error_data;
                return error.code === shaka.util.Error.Code.VIDEO_ERROR && ((_error_data = error.data) === null || _error_data === void 0 ? void 0 : _error_data[1]) === 'c00d7159';
            }
        },
        {
            key: "getEventCvsdkErrorCode",
            value: function getEventCvsdkErrorCode(error, reason) {
                var errorCode = 'SHAKA_ERROR_';
                // DRM errors
                if (reason === ErrorReason.DRM) {
                    errorCode += '_DRM';
                }
                if (this.isErrorHDCP(error)) {
                    errorCode += ERROR_SUFFIX_HDCP_DECODE;
                } else if (this.isErrorWindowsHDCP(error)) {
                    /* https://github.com/sky-uk/core-video-team/issues/4737
             * TODO create a specific error for Edge/Xbox One where the monitor is turned off
             * or goes to sleep so it can be ignored in Conviva
             */ errorCode += ERROR_SUFFIX_WINDOWS_HDCP_DECODE;
                } else {
                    errorCode += error.code;
                }
                return errorCode;
            }
        },
        {
            key: "getEventCvsdkErrorReason",
            value: function getEventCvsdkErrorReason(error, chipset) {
                if (error.code === shaka.util.Error.Code.VIDEO_ERROR && JsonUtils.stringify(error.data).includes('PIPELINE_ERROR_DECODE') && (chipset === '5581P' || chipset === '5597')) {
                    return ErrorReason.VizioUnrecoverablePipelineErrorDecode;
                }
                if (this.isErrorHDCP(error) || this.isErrorWindowsHDCP(error)) {
                    return ErrorReason.HDCP;
                }
                switch(error.category){
                    case shaka.util.Error.Category.DRM:
                        if (this.isDrmErrorUndetermined(error, chipset)) {
                            this.logger.info("Reason for error ".concat(error.code, " is now undetermined. Session is eligible for CDN switch"));
                            return ErrorReason.Undetermined;
                        }
                        return ErrorReason.DRM;
                    default:
                        return ErrorReason.Undetermined;
                }
            }
        },
        {
            key: "isDrmErrorUndetermined",
            value: function isDrmErrorUndetermined(error, chipset) {
                // This specific error on a Vizio 5691 model is recoverable.
                return error.code === shaka.util.Error.Code.FAILED_TO_GENERATE_LICENSE_REQUEST && chipset === '5691' && JsonUtils.stringify(error.data).includes("Failed to execute 'generateRequest' on 'MediaKeySession': Unfulfilled promise rejected automatically during destruction. (1000002)");
            }
        },
        {
            key: "getEventCvsdkErrorMessageAndParams",
            value: // eslint-disable-next-line complexity -- https://gspcloud.atlassian.net/browse/VPTJS-12882
            function getEventCvsdkErrorMessageAndParams(error) {
                /* See https://shaka-player-demo.appspot.com/docs/api/shaka.util.Error.html
         * Strip dynamic values such as URI from error event message and place them in `parameters` to be sent in
         * a separate conviva event.
         */ var errorBody = null;
                var parameters = undefined;
                try {
                    switch(error.code){
                        // 4012
                        case shaka.util.Error.Code.RESTRICTIONS_CANNOT_BE_MET:
                            {
                                var _errorData__restrictedKeyStatuses, _errorData_;
                                var errorData = error.data;
                                errorBody = JsonUtils.stringify(errorData);
                                if ((errorData === null || errorData === void 0 ? void 0 : (_errorData_ = errorData[0]) === null || _errorData_ === void 0 ? void 0 : (_errorData__restrictedKeyStatuses = _errorData_.restrictedKeyStatuses) === null || _errorData__restrictedKeyStatuses === void 0 ? void 0 : _errorData__restrictedKeyStatuses[0]) === 'output-restricted') {
                                    errorBody += " CustomErrorMessage: This is likely to be due to your machine being connected to an external monitor, disconnect it to be able to play";
                                }
                            }
                            break;
                        // 1000
                        case shaka.util.Error.Code.UNSUPPORTED_SCHEME:
                            {
                                var _error_data = _sliced_to_array(error.data, 1), uri = _error_data[0];
                                parameters = {
                                    uri: uri
                                };
                            }
                            break;
                        // 1001
                        case shaka.util.Error.Code.BAD_HTTP_STATUS:
                            {
                                var _error_data1 = _sliced_to_array(error.data, 5), uri1 = _error_data1[0], statusCode = _error_data1[1], responseText = _error_data1[2], responseHeaders = _error_data1[3], networkingEngineRequestType = _error_data1[4];
                                errorBody = "Status Code: ".concat(statusCode, " NetworkingEngine.RequestType: ").concat(networkingEngineRequestType);
                                parameters = {
                                    uri: uri1,
                                    statusCode: String(statusCode),
                                    responseText: String(responseText),
                                    responseHeaders: JsonUtils.stringify(responseHeaders),
                                    networkingEngineRequestType: String(networkingEngineRequestType)
                                };
                            }
                            break;
                        // 1002
                        case shaka.util.Error.Code.HTTP_ERROR:
                            {
                                var _error_data2 = _sliced_to_array(error.data, 3), uri2 = _error_data2[0], originalError = _error_data2[1], networkingEngineRequestType1 = _error_data2[2];
                                errorBody = "Original Error: ".concat(originalError, " NetworkingEngine.RequestType: ").concat(networkingEngineRequestType1);
                                parameters = {
                                    uri: uri2,
                                    originalError: String(originalError),
                                    networkingEngineRequestType: String(networkingEngineRequestType1)
                                };
                            }
                            break;
                        // 1003
                        case shaka.util.Error.Code.TIMEOUT:
                            {
                                var _error_data3 = _sliced_to_array(error.data, 2), uri3 = _error_data3[0], networkingEngineRequestType2 = _error_data3[1];
                                errorBody = "NetworkingEngine.RequestType: ".concat(networkingEngineRequestType2);
                                parameters = {
                                    uri: uri3,
                                    networkingEngineRequestType: String(networkingEngineRequestType2)
                                };
                            }
                            break;
                        // 1004
                        case shaka.util.Error.Code.MALFORMED_DATA_URI:
                            {
                                var _error_data4 = _sliced_to_array(error.data, 1), uri4 = _error_data4[0];
                                parameters = {
                                    uri: uri4
                                };
                            }
                            break;
                        // 3016
                        case shaka.util.Error.Code.VIDEO_ERROR:
                            {
                                var HEX_CODE_OPM_NOT_SUPPORTED = '0XC0262500';
                                var _error_data5 = _sliced_to_array(error.data, 3), _ = _error_data5[0], edgeMicrosoftHexCode = _error_data5[1], chromeErrorDetails = _error_data5[2];
                                errorBody = JsonUtils.stringify(error.data);
                                if (String(edgeMicrosoftHexCode).toUpperCase() === HEX_CODE_OPM_NOT_SUPPORTED || String(chromeErrorDetails).toUpperCase().includes(HEX_CODE_OPM_NOT_SUPPORTED)) {
                                    errorBody += ' Custom Message: The graphics driver does not support Output Protection. For example, the monitor is' + ' connected through VGA or an appropriate graphics driver for the digital output is not installed. In the latter case,' + ' the typical driver that is installed is the Microsoft Basic Display Adapter and installing an appropriate graphics' + ' driver will resolve the issue.';
                                }
                            }
                            break;
                        // 4000
                        case shaka.util.Error.Code.UNABLE_TO_GUESS_MANIFEST_TYPE:
                            {
                                var _error_data6 = _sliced_to_array(error.data, 1), uri5 = _error_data6[0];
                                parameters = {
                                    uri: uri5
                                };
                            }
                            break;
                        // 4001
                        case shaka.util.Error.Code.DASH_INVALID_XML:
                            {
                                var _error_data7 = _sliced_to_array(error.data, 1), uri6 = _error_data7[0];
                                parameters = {
                                    uri: uri6
                                };
                            }
                            break;
                        // 6007
                        case shaka.util.Error.Code.LICENSE_REQUEST_FAILED:
                            {
                                var _error_data8 = _sliced_to_array(error.data, 1), networkError = _error_data8[0];
                                var data = networkError.data, parametersToInclude = _object_without_properties(networkError, [
                                    "data"
                                ]);
                                errorBody = JsonUtils.stringify(parametersToInclude);
                                parameters = {
                                    networkError: JsonUtils.stringify(networkError)
                                };
                            }
                            break;
                        // 6008
                        case shaka.util.Error.Code.LICENSE_RESPONSE_REJECTED:
                            {
                                var _error_data9 = _sliced_to_array(error.data, 1), browserMessage = _error_data9[0];
                                parameters = {
                                    browserMessage: browserMessage
                                };
                            }
                            break;
                        // 6017
                        case shaka.util.Error.Code.SERVER_CERTIFICATE_REQUEST_FAILED:
                        case 6017:
                            {
                                var _error_data10 = _sliced_to_array(error.data, 1), networkError1 = _error_data10[0];
                                parameters = {
                                    networkError: JsonUtils.stringify(networkError1)
                                };
                            }
                            break;
                        // 9003
                        case shaka.util.Error.Code.REQUESTED_ITEM_NOT_FOUND:
                            {
                                var _error_data11 = _sliced_to_array(error.data, 1), uri7 = _error_data11[0];
                                parameters = {
                                    uri: uri7
                                };
                            }
                            break;
                        // 9004
                        case shaka.util.Error.Code.MALFORMED_OFFLINE_URI:
                            {
                                var _error_data12 = _sliced_to_array(error.data, 1), uri8 = _error_data12[0];
                                parameters = {
                                    uri: uri8
                                };
                            }
                            break;
                        // 9005
                        case shaka.util.Error.Code.CANNOT_STORE_LIVE_OFFLINE:
                            {
                                var _error_data13 = _sliced_to_array(error.data, 1), uri9 = _error_data13[0];
                                parameters = {
                                    uri: uri9
                                };
                            }
                            break;
                        default:
                            {
                                var _error_data14;
                                errorBody = Array.isArray(error.data) ? JsonUtils.stringify(error.data) : (_error_data14 = error.data) === null || _error_data14 === void 0 ? void 0 : _error_data14.toString();
                            }
                            break;
                    }
                } catch (e) {
                    // In the case the error data is formed differently than expected, default to stringify the error
                    errorBody = JsonUtils.stringify(error.data);
                }
                var errorMessageBase = "Code: ".concat(error.code, " Category: ").concat(error.category, " Severity: ").concat(error.severity);
                return {
                    message: "".concat(errorMessageBase).concat(errorBody ? ' ' + errorBody : ''),
                    parameters: parameters
                };
            }
        },
        {
            key: "fromError",
            value: function fromError(error, chipset) {
                var severity = (error === null || error === void 0 ? void 0 : error.severity) === shaka.util.Error.Severity.CRITICAL ? ErrorSeverity.Fatal : ErrorSeverity.Warning;
                if (!(error === null || error === void 0 ? void 0 : error.code)) {
                    return ShakaPlayerError.from({
                        code: 'SHAKA_ERROR_UNHANDLED',
                        message: "Unhandled error Severity: ".concat(error === null || error === void 0 ? void 0 : error.severity, " ").concat(JsonUtils.stringify(error), " ").concat(error),
                        severity: severity
                    });
                }
                var _this_getEventCvsdkErrorMessageAndParams = this.getEventCvsdkErrorMessageAndParams(error), message = _this_getEventCvsdkErrorMessageAndParams.message, parameters = _this_getEventCvsdkErrorMessageAndParams.parameters;
                var reason = this.getEventCvsdkErrorReason(error, chipset || '');
                var code = this.getEventCvsdkErrorCode(error, reason);
                return ShakaPlayerError.from({
                    code: code,
                    message: message,
                    severity: severity,
                    parameters: parameters,
                    reason: reason,
                    cause: error
                });
            }
        },
        {
            key: "playerLoadError",
            value: function playerLoadError(param) {
                var error = param.error, customMessage = param.customMessage;
                var playerLoadErrorCode = 'SDK.PLAYER_ERROR.PLAYER_LOAD_ERROR';
                if (error === undefined) {
                    return ShakaPlayerError.from({
                        code: playerLoadErrorCode,
                        message: customMessage !== null && customMessage !== void 0 ? customMessage : '',
                        severity: ErrorSeverity.Fatal
                    });
                }
                var _this_getEventCvsdkErrorMessageAndParams = this.getEventCvsdkErrorMessageAndParams(error), message = _this_getEventCvsdkErrorMessageAndParams.message, parameters = _this_getEventCvsdkErrorMessageAndParams.parameters;
                return ShakaPlayerError.from({
                    code: playerLoadErrorCode,
                    message: "Shaka error: ".concat(message),
                    severity: ErrorSeverity.Fatal,
                    parameters: parameters
                });
            }
        }
    ]);
    return ShakaPlayerError;
}(CvsdkError);
_define_property(ShakaPlayerError, "logger", sdkLogger.withContext('ShakaPlayerError'));

//# sourceMappingURL=shaka-player-error.js.map